import { useParams } from 'react-router-dom';

import type { UploadHistory } from '@/api/types/backend-dto-types';
import { FileUploader } from '@/new/components/file-uploader';

export function MatterCreatorFiles({
  uploadHistory,
  setFilesProcessing,
}: {
  uploadHistory: UploadHistory[] | undefined;
  setFilesProcessing: (processing: boolean) => void;
}) {
  const { matterId } = useParams();

  if (!matterId) return null;

  return <FileUploader uploadHistory={uploadHistory} setFilesProcessing={setFilesProcessing} isMatterCreator={true} />;
}
